import { Collapse } from 'bootstrap';
import $ from 'jquery';

export default function templateFunctions() {
  const hideSidebarCollapses = () => {
    document.querySelectorAll('.sidebar .collapse').forEach((element) => {
      Collapse.getOrCreateInstance(element).hide();
    });
  };

  // Toggle the side navigation
  $("#sidebarToggleTop").on('click', function(e) {
    $("body").toggleClass("sidebar-toggled");
    $(".sidebar").toggleClass("toggled");
    if ($(".sidebar").hasClass("toggled")) {
      hideSidebarCollapses();
    };

    $("#content-wrapper").toggleClass("room-for-sidebar");
  });

  // Close any open menu accordions when window is resized below 768px
  $(window).resize(function() {
    if ($(window).width() < 768) {
      hideSidebarCollapses();
    };
  });

  // Prevent the content wrapper from scrolling when the fixed side navigation hovered over
  $('body.fixed-nav .sidebar').on('mousewheel DOMMouseScroll wheel', function(e) {
    if ($(window).width() > 768) {
      var e0 = e.originalEvent,
        delta = e0.wheelDelta || -e0.detail;
      this.scrollTop += (delta < 0 ? 1 : -1) * 30;
      e.preventDefault();
    }
  });

  // Scroll to top button appear
  $(document).on('scroll', function() {
    var scrollDistance = $(this).scrollTop();
    if (scrollDistance > 100) {
      $('.scroll-to-top').fadeIn();
    } else {
      $('.scroll-to-top').fadeOut();
    }
  });

  $('.scroll-to-top').on('click', function() {
    $('html').animate({scrollTop: 0 }, 'slow');
    $('body').animate({scrollTop: 0 }, 'slow');
    $('document').animate({scrollTop: 0 }, 'slow');
    $('window').animate({scrollTop: 0 }, 'slow');
  });
}
